import { render, staticRenderFns } from "./MsTextarea.vue?vue&type=template&id=f707ec66&scoped=true"
import script from "./MsTextarea.vue?vue&type=script&lang=js"
export * from "./MsTextarea.vue?vue&type=script&lang=js"
import style0 from "./MsTextarea.vue?vue&type=style&index=0&id=f707ec66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f707ec66",
  null
  
)

export default component.exports